import { ReadonlyField, type ReadonlyFieldProps } from '@shared/components';
import { type FieldValues } from 'react-hook-form';

import type { BaseInputModeProps, BaseViewModeProps } from '../../types';
import { MaskFormTextField, type MaskFormTextFieldProps } from '../mask-form-text-field';

type InputModeProps = BaseInputModeProps<Omit<MaskFormTextFieldProps<FieldValues>, 'name'>>;

type ViewModeProps = BaseViewModeProps<Omit<ReadonlyFieldProps, 'content'>>;

export type MaskTextFieldRendererProps = InputModeProps | ViewModeProps;

export default function MaskTextFieldRenderer(props: Readonly<MaskTextFieldRendererProps>) {
  switch (props.mode) {
    case 'input': {
      const { name, slotProps: { maskOptions = {}, ...restSlotProps } = {} } = props;
      return <MaskFormTextField name={name} maskOptions={maskOptions} {...restSlotProps} />;
    }
    case 'view': {
      const { value, slotProps } = props;
      return <ReadonlyField content={value} {...slotProps} />;
    }
  }
}
